import React from 'react'


class Typing extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            toRotate:props.dataType || [],
            loopNum:0,
            period:parseInt(props.dataPeriod, 10) || 2000,
            txt:'',
            isMounted:false
        }
    }
    TextType(){
        this.tick();
        this.isDeleting = false;
    }
    tick(){
        if(!this.typewrite){
            return
        }
        let i = this.state.loopNum % this.state.toRotate.length;
        let fullTxt = this.state.toRotate[i];

        if (this.isDeleting) {
            this.setState({txt:fullTxt.substring(0, this.state.txt.length - 1)})
        } else {
            this.setState({txt:fullTxt.substring(0, this.state.txt.length + 1)})
        }
        let delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.state.txt === fullTxt) {
            delta = this.state.period;
            this.isDeleting = true;
        } else if (this.isDeleting && this.state.txt === '') {
            this.isDeleting = false;
            this.setState({
                loopNum:this.state.loopNum+1
            });
            delta = 500;
        }

        setTimeout(()=> {
            this.tick();
        }, delta);
    }
    componentDidMount(){
        this.TextType()
    }
    render(){
        return <span className="typewrite">
                <span className={'wrap'} ref={type =>this.typewrite = type}>{this.state.txt}</span>
            </span>
    }
}

export default Typing


// WEBPACK FOOTER //
// ./src/components/common/Typing.js